import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { COLORS } from '../../../styles/constants';
import { useHelperTextStyles } from '../styles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const InputVoltage = ({ screenWidth, appliedValue, ...props }) => {
	const { t } = useTranslation();
	const helperTextStyles = useHelperTextStyles();
	const { values, handleBlur } = props.formikProps;
	const appliedStateOfQuickFilter = useSelector(state => state.filters.appliedState);
	const supplyTypeState = appliedStateOfQuickFilter.pwcv.value.toString().substring(0, 2);
	const vinMinState = appliedStateOfQuickFilter.vin.value;
	const vinMaxState = appliedStateOfQuickFilter.vim.value;
	let logChange = document.getElementById('logChange');
	function handleChange() {
		logChange.textContent = '';
	}

	return (
		<Grid>
			<Grid
				container
				style={{
					alignItems: 'center',
					paddingBottom: '12px'
				}}>
				<span
					style={{
						whiteSpace: 'pre'
					}}>
					{t('main:components.wdValidators.input.inputVoltage.supplyType')}:{'  '}
				</span>
				<span
					style={{
						color: COLORS.SECONDARY,
						fontWeight: 'bold'
					}}>
					{supplyTypeState === 'Al' ? '\u2014' : (values.supplyType = supplyTypeState)}
				</span>
				{supplyTypeState === 'Al' ? (
					<div
						style={{
							color: COLORS.TEXT_SECONDARY,
							fontSize: '10.5px',
							paddingBottom: '0px'
						}}></div>
				) : (
					<div></div>
				)}
			</Grid>
			<Grid>
				<label htmlFor="Input__vinMax_text_field">
					<span>
						{supplyTypeState === 'DC' && (
							<span>
								V
								<sub>
									IN<sub>DC</sub> (max)
								</sub>
								:{' '}
							</span>
						)}
						{supplyTypeState === 'AC' && (
							<span>
								V
								<sub>
									IN<sub>RMS</sub> (max)
								</sub>
								:{' '}
							</span>
						)}
						{supplyTypeState === 'Al' && (
							<span>
								V
								<sub>
									IN<sub>DC/RMS</sub> (max)
								</sub>
								:{' '}
							</span>
						)}
						{appliedStateOfQuickFilter.vim.isDirty === true ? (
							<span>
								<span
									style={{
										color: COLORS.SECONDARY,
										fontWeight: 'bold'
									}}>
									{(values.vinMax = vinMaxState)}
								</span>
								<span
									style={{
										color: COLORS.TEXT_SECONDARY
									}}>
									{' '}
									[V]
								</span>
							</span>
						) : (
							<span
								style={{
									color: COLORS.SECONDARY,
									fontWeight: 'bold'
								}}>
								{'\u00a0' + '\u2014'} <div style={{ height: '13px' }}></div>
							</span>
						)}
					</span>
				</label>
				<Grid>
					{appliedStateOfQuickFilter.vim.isDirty === false ? (
						<div
							style={{
								color: COLORS.TEXT_SECONDARY,
								fontSize: '10.5px',
								paddingBottom: '10px'
							}}></div>
					) : (
						<>
							<span>
								<TextField
									id="Input__vinMax_text_field"
									name="vinMax"
									InputProps={{
										readOnly: true,
										disableUnderline: true
									}}
									maxLength={0}
									onChange={handleChange}
									onBlur={handleBlur}
									value={''}
									FormHelperTextProps={{
										classes: {
											root: helperTextStyles.root
										}
									}}
								/>
								<p className={helperTextStyles.root} id="logChange">
									{vinMinState > vinMaxState ? (
										<span>
											{supplyTypeState === 'DC' && (
												<span>
													V
													<sub>
														IN<sub>DC</sub> (max)
													</sub>{' '}
													must be {'>'}= V
													<sub>
														IN<sub>DC</sub> (min)
													</sub>
												</span>
											)}
											{supplyTypeState === 'AC' && (
												<span>
													V
													<sub>
														IN<sub>RMS</sub> (max)
													</sub>{' '}
													must be {'>'}= V
													<sub>
														IN<sub>RMS</sub> (min)
													</sub>
												</span>
											)}
											{supplyTypeState === 'Al' && (
												<span>
													V
													<sub>
														IN<sub>DC/RMS</sub> (max)
													</sub>{' '}
													must be {'>'}= V
													<sub>
														IN<sub>DC/RMS</sub> (min)
													</sub>
												</span>
											)}
										</span>
									) : (
										<span style={{ marginBottom: '20px' }}>{'\u00a0'}</span>
									)}
								</p>
							</span>
						</>
					)}
				</Grid>
			</Grid>

			<Grid>
				<label htmlFor="Input__vinMin_text_field">
					<span>
						{supplyTypeState === 'DC' && (
							<span>
								V
								<sub>
									IN<sub>DC</sub> (min)
								</sub>
								:{' '}
							</span>
						)}
						{supplyTypeState === 'AC' && (
							<span>
								V
								<sub>
									IN<sub>RMS</sub> (min)
								</sub>
								:{' '}
							</span>
						)}
						{supplyTypeState === 'Al' && (
							<span>
								V
								<sub>
									IN<sub>DC/RMS</sub> (min)
								</sub>
								:{' '}
							</span>
						)}
						{appliedStateOfQuickFilter.vin.isDirty === true ? (
							<span>
								<span
									style={{
										color: COLORS.SECONDARY,
										fontWeight: 'bold'
									}}>
									{(values.vinMin = vinMinState)}
								</span>
								<span
									style={{
										color: COLORS.TEXT_SECONDARY
									}}>
									{' '}
									[V]
								</span>
							</span>
						) : (
							<span
								style={{
									color: COLORS.SECONDARY,
									fontWeight: 'bold'
								}}>
								{'\u00a0' + '\u2014'}
							</span>
						)}
					</span>
				</label>
				<Grid>
					{appliedStateOfQuickFilter.vin.isDirty === false ? (
						<div
							style={{
								color: COLORS.TEXT_SECONDARY,
								fontSize: '10.5px'
							}}></div>
					) : (
						<>
							<span>
								<TextField
									id="Input__vinMin_text_field"
									name="vinMin"
									InputProps={{
										readOnly: true,
										disableUnderline: true
									}}
									maxLength={0}
									onChange={handleChange}
									onBlur={handleBlur}
									value={''}
									FormHelperTextProps={{
										classes: {
											root: helperTextStyles.root
										}
									}}
								/>
								<p className={helperTextStyles.root} id="logChange">
									{vinMinState > vinMaxState ? (
										<span>
											{supplyTypeState === 'DC' && (
												<span>
													V
													<sub>
														IN<sub>DC</sub> (min)
													</sub>{' '}
													must be {'<'}= V
													<sub>
														IN<sub>DC</sub> (max)
													</sub>
												</span>
											)}
											{supplyTypeState === 'AC' && (
												<span>
													V
													<sub>
														IN<sub>RMS</sub> (min)
													</sub>{' '}
													must be {'<'}= V
													<sub>
														IN<sub>RMS</sub> (max)
													</sub>
												</span>
											)}
											{supplyTypeState === 'Al' && (
												<span>
													V
													<sub>
														IN<sub>DC/RMS</sub> (min)
													</sub>{' '}
													must be {'<'}= V
													<sub>
														IN<sub>DC/RMS</sub> (max)
													</sub>
												</span>
											)}
										</span>
									) : (
										<span style={{ marginBottom: '20px' }}>{'\u00a0'}</span>
									)}
								</p>
							</span>
						</>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};

InputVoltage.propTypes = {
	screenWidth: PropTypes.number.isRequired
};

export default InputVoltage;
